module.exports = ".p-img {\n  width: 80px; }\n\n.my-pagination::ng-deep .ngx-pagination .current {\n  background: #84c225 !important; }\n"